// Module scope, not component or hook state: the surfaces that queue work here unmount
// while it is still running — the capture tool is swapped away for the chat composer, the
// chat panel closes — and a queue held in a ref would die with it and abandon the work.
//
// Serial per key is also what upholds the callers' invariants: one capture session starts
// exactly one Observation because its next submit cannot begin until the previous one has
// recorded its group, and one chat cannot stream two turns at once.
const tailByKey = new Map<string, Promise<void>>();

export function enqueueSerial(key: string, task: () => Promise<void>): void {
  const tail = tailByKey.get(key) ?? Promise.resolve();
  // The catch is a backstop, not error handling: a task is expected to resolve its own
  // failures. Were one to throw, a rejected tail would stop every later task for the key,
  // which is a far worse failure than the throw itself.
  const next = tail.then(() => task()).catch((error: unknown) => {
    console.error('Serial queue task failed', { key, error });
  });
  tailByKey.set(key, next);
  void next.then(() => {
    if (tailByKey.get(key) === next) tailByKey.delete(key);
  });
}

export function whenSerialIdle(key: string): Promise<void> {
  return tailByKey.get(key) ?? Promise.resolve();
}
